import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import CalendarContainer from "../../../containers/activite/planning/";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../../redux/actions/menuActions";
import MenuActivite from "../Menu";

class Calendar extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("activite");
    this.props.setMenuLeftContent(MenuActivite);
    this.props.setMenuLeftIndex("planning");
    this.props.setMenuLeftItemIndex("planning-list");
  }

  render() {
    return (
      <Fragment>
        <CalendarContainer {...this.props} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    setMenuLeftContent: content => {
      dispatch(setMenuLeftContent(content));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);



// WEBPACK FOOTER //
// src/pages/activite/planning/Calendar.js